var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessfullyRepairedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 4,
    fill: "#2F80ED",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7112 15.233L17.6705 28.2737C17.3658 28.5782 16.9527 28.7492 16.5219 28.7492C16.0911 28.7492 15.6779 28.5782 15.3732 28.2737L8.0993 20.9612C7.79509 20.6565 7.62423 20.2436 7.62423 19.813C7.62423 19.3825 7.79509 18.9695 8.0993 18.6648L10.1305 16.6336C10.4351 16.3303 10.8474 16.16 11.2772 16.16C11.707 16.16 12.1193 16.3303 12.4238 16.6336L16.5625 20.6473L26.3897 10.941C26.6943 10.6374 27.1068 10.467 27.5368 10.467C27.9669 10.467 28.3794 10.6374 28.684 10.941L30.7102 12.9255C30.8625 13.0765 30.9835 13.2562 31.0661 13.4542C31.1487 13.6522 31.1912 13.8646 31.1913 14.0791C31.1914 14.2936 31.149 14.506 31.0666 14.7041C30.9842 14.9021 30.8634 15.0819 30.7112 15.233Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfullyRepairedIcon);
export default __webpack_public_path__ + "static/media/successfully-repaired-icon.f9d2a83758b6883ffe1c580a1277b4e1.svg";
export { ForwardRef as ReactComponent };